module.exports = __webpack_public_path__ + "static/media/section3bg.0d8b551b.png";